import {
	buildPageStaggerIndexMap,
	computePageStaggerTimings,
	shouldApplyStaggerPageElementTransition,
	sortElementsForPageStagger,
} from "./escapeRoomPageStaggerUtils";

export { buildPageStaggerIndexMap as buildComicStaggerIndexMap, sortElementsForPageStagger as sortElementsForComicStagger };

export function shouldApplyComicPageElementTransition(ctx) {
	return shouldApplyStaggerPageElementTransition("comic", ctx);
}

function comicRotationForIndex(index, elementId) {
	const base = [-8, 6, -5, 7][index % 4];
	let hash = 0;
	const id = String(elementId ?? index);
	for (let i = 0; i < id.length; i += 1) hash = ((hash << 5) - hash + id.charCodeAt(i)) | 0;
	return base + (Math.abs(hash) % 3) - 1;
}

export function getComicPageTransitionElementStyle(staggerIndex, totalCount, durationMs, elementId) {
	const idx = Math.max(0, staggerIndex || 0);
	const { panelSec, delaySec } = computePageStaggerTimings(durationMs, totalCount, { panelRatio: 0.4 });
	const rot = comicRotationForIndex(idx, elementId);
	return {
		opacity: 0,
		transformOrigin: "center center",
		"--er-comic-rot": `${rot}deg`,
		animation: `er-page-comic-panel ${panelSec}s cubic-bezier(0.34, 1.45, 0.64, 1) ${delaySec(idx)}s both`,
		willChange: "opacity, transform",
	};
}

export function getComicPageBackgroundStyle(durationMs) {
	const { totalSec } = computePageStaggerTimings(durationMs, 1, { panelRatio: 0.35 });
	const sec = Math.max(0.2, totalSec * 0.3);
	return {
		opacity: 0,
		animation: `er-page-comic-bg ${sec}s ease-out both`,
		willChange: "opacity, transform",
	};
}
